var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCupWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.86704 4.82272L1 1",
    stroke: "#fff",
    strokeWidth: 1.43084,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4747 5.18961C13.4525 5.02341 13.4747 4.97909 13.4747 4.81288C13.4747 2.74085 15.1589 1.05664 17.242 1.05664C19.3251 1.05664 20.9983 2.74085 20.9983 4.81288C20.9983 6.88491 19.314 8.5802 17.242 8.5802C16.4775 8.5802 15.7683 8.35859 15.1811 7.97078",
    stroke: "#fff",
    strokeWidth: 1.43084,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50945 22.4622H5.86401C5.69781 22.4622 5.60916 22.2627 5.71997 22.1298L8.02468 19.6145V12.1685L1.2435 4.97739C1.1881 4.92199 1.23242 4.82227 1.30999 4.82227H17.4541C17.5427 4.82227 17.587 4.93307 17.5316 4.98847L10.7726 12.1685V19.6145L13.0662 22.1187C13.1881 22.2517 13.0884 22.4511 12.9222 22.4511H9.28784",
    stroke: "#fff",
    strokeWidth: 1.43084,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5942 7.03906H3.19531",
    stroke: "#fff",
    strokeWidth: 1.43084,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupWhite);
export default __webpack_public_path__ + "static/media/cup_white.6dbc8d7b55da8193818033b9f2f5bdd5.svg";
export { ForwardRef as ReactComponent };